<section>
	<div class="row m-3">
        <div class="col">
            <span *ngIf="isLoading" class="throbber"></span>
            <div *ngIf="!isLoading && !cropGenotypingParameter" class="alert alert-danger" role="alert">
                <span jhiTranslate="genotyping.parameters.not.configured"></span>
            </div>
            <div *ngIf="!isLoading && cropGenotypingParameter" class="alert alert-success" role="alert">
                <span jhiTranslate="genotyping.server.opened.in.new.tab"></span>
            </div>
        </div>
	</div>
</section>
